import { SVButton } from '@/components/core';
import { MESSAGES } from '@/constants/messages';
import { useResendActivationStatus } from '@/hooks/requests/useAccountActivation';
import showToast from '@/utils/toast';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';

type ResendActivationModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  email: string;
};

export default function ResendActivationModal({
  open,
  setOpen,
  email,
}: ResendActivationModalProps) {
  const { resendActivation, isLoadingResendActivation } =
    useResendActivationStatus();

  async function handleResend() {
    try {
      await resendActivation({ email });
      showToast({
        type: 'success',
        data: {
          content:
            'A reactivation email has been successfully sent to the customer',
        },
      });
      setOpen(false);
    } catch {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  }

  return (
    <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <Typography variant="h6" component="h2" mb={2}>
          Resend Activation Email
        </Typography>
        <Typography>
          Are you sure you would like to resend the customer their mobile app
          activation email?
        </Typography>
      </DialogContent>
      <DialogActions>
        <SVButton onClick={() => setOpen(false)} variant="tertiary">
          Cancel
        </SVButton>
        <SVButton isLoading={isLoadingResendActivation} onClick={handleResend}>
          Yes, send email
        </SVButton>
      </DialogActions>
    </Dialog>
  );
}
